const axios = require("axios");
import router from "../router"; // use router/index.js path
import Options from "../../options";
import store from "@/store";

const envApiBase = String(process.env.VUE_APP_API_BASE_URL || "").trim();
const baseDomain = envApiBase
  ? envApiBase.endsWith("/")
    ? envApiBase
    : `${envApiBase}/`
  : Options.useDevServer
  ? Options.devServerUrl
  : Options.prodServerUrl;

const baseURL = `${baseDomain}`;

const axiosInstance = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* DYNAMICALLY UPDATING HEADERS SET HERE */
axiosInstance.interceptors.request.use(function (config) {
  let token = localStorage.getItem("token");
  if (token !== null) {
    config.headers["Authorization"] = "JWT " + token;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    console.log(error);
    if (!error || !error.response) {
      return Promise.reject(error);
    }
    const status = error.response.status;
    if (status === 404) {
      // JSON API 404s (e.g. koneko-a not deployed yet) must not hijack SPA navigation.
      // Pushing a missing route name aborted /koneko-a → Dashboard/Home.
      const reqUrl = String(
        (error.config && (error.config.url || error.config.baseURL)) || ""
      );
      const isJsonApi =
        /^\s*api\//i.test(reqUrl) ||
        reqUrl.includes("/nekoapi/") ||
        reqUrl.includes("/api/");
      if (!isJsonApi) {
        router.push({name: "404Error"}).catch(() => {});
      }
    } else if (status === 401) {
      store.dispatch("AUTH_LOGOUT_REQUEST");
      router.push({name: "Login"}).catch(() => {});
    } else if (status === 400) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

/** Resolved at build time — shown in dev wiring hints. */
export const resolvedNekoApiBaseUrl = baseURL;

export function isLocalTimerV1Configured() {
  const raw = String(process.env.VUE_APP_TIMER_V1_API_BASE_URL || "").trim();
  return Boolean(raw && /localhost|127\.0\.0\.1/i.test(raw));
}

export function resolvedTimerV1BaseUrl() {
  const raw = String(process.env.VUE_APP_TIMER_V1_API_BASE_URL || "").trim();
  return raw ? raw.replace(/\/?$/, "/") : "";
}

export default axiosInstance;
